/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { useCallback, useEffect, useState } from "react";
import { CellValue } from "@inscopix/ideas-hyperformula";

const styles = {
  root: css`
    border: none;
    background-color: transparent;
    width: 100%;
    &:focus {
      outline: none;
    }
  `,
};

interface CellEditorNumberProps {
  eventKey: string | null;
  value: CellValue;
  onChangeFormula: (newFormula: string) => void;
  stopEditing: (cancel?: boolean) => void;
}

/** Cell editor for cells in integer and float columns */
export const CellEditorNumber = ({
  eventKey,
  value,
  onChangeFormula,
  stopEditing,
}: CellEditorNumberProps) => {
  const [newValue, setNewValue] = useState(() => {
    if (
      typeof value === "string" ||
      typeof value === "boolean" ||
      typeof value === "number"
    ) {
      return value.toString();
    } else {
      return "";
    }
  });

  const handleChange = useCallback(
    (newValue: string) => {
      setNewValue(newValue);
      let newFormula = "";
      if (newValue === "") {
        newFormula = newValue;
      }
      // Prepend the value with ' to coerce it to a text formula
      else if (Number.isNaN(Number(newValue))) {
        newFormula = `'${newValue}`;
      } else {
        newFormula = newValue;
      }
      onChangeFormula(newFormula);
    },
    [onChangeFormula],
  );

  // If cell editing began as the result of a key press, add the pressed to new
  // value
  useEffect(() => {
    if (eventKey !== null && eventKey.length === 1) {
      handleChange(eventKey);
    }
  }, [eventKey, handleChange]);

  return (
    <input
      autoFocus
      type="text"
      css={styles.root}
      value={newValue}
      onBlur={() => stopEditing()}
      onChange={(e) => handleChange(e.target.value)}
    />
  );
};
